// removed by extract-text-webpack-plugin
module.exports = {"heading":"_3Dqqh","centralHeading":"_1KXLd _3Dqqh","centralBody":"_1sSaG","centralSection":"_2mbAl","hideOnMobile":"_2eR5r"};